
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.797 8.203C4.461 6.866 4.159 5.53 4.091 4.995a.48.48 0 01.138-.402l1.081-1.08a.483.483 0 00.068-.598L3.656.24a.483.483 0 00-.625-.176L.267 1.367a.48.48 0 00-.265.48C.146 3.222.746 6.605 4.07 9.929c3.324 3.324 6.705 3.923 8.082 4.068.2.02.391-.085.48-.265l1.302-2.764a.483.483 0 00-.175-.625l-2.674-1.721a.483.483 0 00-.598.067l-1.08 1.082a.48.48 0 01-.402.138c-.535-.068-1.872-.37-3.208-1.706z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.103 7.483A.483.483 0 0110.621 7 3.625 3.625 0 007 3.38a.483.483 0 010-.966A4.591 4.591 0 0111.586 7a.483.483 0 01-.483.483z","fill":"#fff"}}),_c('path',{attrs:{"d":"M13.517 7.483A.483.483 0 0113.034 7 6.041 6.041 0 007 .966.483.483 0 117 0a7.008 7.008 0 017 7 .483.483 0 01-.483.483z","fill":"#fff"}})])
          )
        }
      }
    